"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsKeyboardButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsVirtualKeyboard = require("../DmsVirtualKeyboard/DmsVirtualKeyboard");
var _material = require("@mui/material");
var _Keyboard = _interopRequireDefault(require("@mui/icons-material/Keyboard"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsKeyboardButton renders a virtual keyboard and an optional button to toggle it.
 * The keyboard can be set to open automatically on input focus, even if the button is hidden.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {boolean} [props.hide=false] - If true, the toggle button will be hidden.
 * @param {Object} [props.iconButtonSx={}] - Optional styles for the `IconButton` component.
 * @param {Object} [props.iconSx={}] - Optional styles for the `KeyboardIcon` component.
 * @returns {JSX.Element} The rendered virtual keyboard and, optionally, the toggle button.
 */
const DmsKeyboardButton = _ref => {
  let {
    iconButtonSx = {},
    iconSx = {},
    hide = false
  } = _ref;
  const [showVirtualKeyboard, setShowVirtualKeyboard] = (0, _react.useState)(false);
  const [currentInputValue, setCurrentInputValue] = (0, _react.useState)(null);
  const [focus, setFocus] = (0, _react.useState)(null);

  /**
   * Toggles the visibility of the virtual keyboard when the button is clicked.
   */
  const toggleKeyboard = () => {
    setShowVirtualKeyboard(prev => !prev);
  };

  /**
   * This effect is crucial. It tracks the currently focused input element,
   * which is needed by the DmsVirtualKeyboard component to know where to type.
   * This needs to run regardless of whether the button is visible.
   */
  (0, _react.useEffect)(() => {
    if (!showVirtualKeyboard) return;
    const handleFocus = event => {
      if (["INPUT", "TEXTAREA"].includes(event.target.tagName)) {
        const targetId = event.target.id;
        if (targetId) {
          setFocus({
            [targetId]: event.target
          });
          setCurrentInputValue(targetId);
        }
      }
    };
    document.addEventListener("focusin", handleFocus);
    return () => {
      document.removeEventListener("focusin", handleFocus);
    };
  }, [showVirtualKeyboard]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DmsVirtualKeyboard.DmsVirtualKeyboard, {
    showKeyboard: showVirtualKeyboard,
    focus: focus,
    currentInputValue: currentInputValue,
    setShowKeyboard: setShowVirtualKeyboard
  }), !hide && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: toggleKeyboard,
    sx: iconButtonSx
  }, /*#__PURE__*/_react.default.createElement(_Keyboard.default, {
    sx: iconSx
  })));
};
exports.DmsKeyboardButton = DmsKeyboardButton;
DmsKeyboardButton.propTypes = {
  hide: _propTypes.default.bool,
  iconButtonSx: _propTypes.default.object,
  iconSx: _propTypes.default.object
};